<template>
    <div>
        <div class="vx-row vx-card p-6 mb-4">
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">Hình thức</label>
                <v-select :options="branchCreateOptions" :clearable="false" v-validate="'required'" name="branch">
                    <span slot="no-options"> {{
                    $t('menuOrganization.noOption')
                }}</span>
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">Trạng thái kết nối</label>
                <v-select :options="branchCreateOptions" :clearable="false" v-validate="'required'" name="branch">
                    <span slot="no-options"> {{
                    $t('menuOrganization.noOption')
                }}</span>
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">Trạng thái cuộc gọi</label>
                <v-select :options="branchCreateOptions" :clearable="false" v-validate="'required'" name="branch">
                    <span slot="no-options"> {{
                    $t('menuOrganization.noOption')
                }}</span>
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">Loại cuộc gọi</label>
                <v-select :options="branchCreateOptions" :clearable="false" v-validate="'required'" name="branch">
                    <span slot="no-options"> {{
                    $t('menuOrganization.noOption')
                }}</span>
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">Tag</label>
                <v-select :options="branchCreateOptions" :clearable="false" v-validate="'required'" name="branch">
                    <span slot="no-options"> {{
                    $t('menuOrganization.noOption')
                }}</span>
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">Nhóm</label>
                <v-select :options="branchCreateOptions" :clearable="false" v-validate="'required'" name="branch">
                    <span slot="no-options"> {{
                    $t('menuOrganization.noOption')
                }}</span>
                </v-select>
            </div>
            <div class="vx-col xl:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label required">Nhân viên phụ trách</label>
                <v-select :options="branchCreateOptions" :clearable="false" v-validate="'required'" name="branch">
                    <span slot="no-options"> {{
                    $t('menuOrganization.noOption')
                }}</span>
                </v-select>
            </div>
            <div class="vx-col w-autol">
                <vs-button class="sm:mt-6">Tìm kiếm</vs-button>
            </div>
        </div>
        <!-- <div class=" pb-4 mt-6 vx-row match-height">
            <div class="vx-col lg:w-1/5 md:w-1/3 sm:w-1/2 w-full mt-8" v-for="(data, ind) in dataCallMonitoring"
                :key="ind">
                <div class="user-card">
                    <div class="header py-2 flex justify-center">
                        <span class="font-semibold text-lg text-primary text-center groupName">{{
                    data.groupName
                }}</span>
                    </div>
                    <div class=" items-center justify-center my-2">
                        <div class="mb-16 ml-4">
                            <p>{{ data.ttcg }}</p>
                        </div>
                        <p class="text-primary ml-4">{{ data.stt }}</p>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="vx-row vx-card p-6 mb-8">
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-8" v-for="(data, ind) in dataCallMonitoring"
                :key="ind">
                <vs-card class="cardx" >
                    <div slot="header">
                        <h5>
                            {{
                    data.groupName
                            }}
                        </h5>
                    </div>
                    <div class=" items-center justify-center my-2">
                        <div class="mb-16 ml-4">
                            <p>{{ data.ttcg }}</p>
                        </div>
                        <p class="text-primary ml-4">{{ data.stt }}</p>
                    </div>
                </vs-card>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
    components: {
        vSelect
    },
    data() {
        return {
            dataCallMonitoring: [
                {
                    groupName: "inviv clound",
                    ttcg: 'chưa có thông tin',
                    stt: 'Không hoạt động',
                },
                {
                    groupName: "inviv clound",
                    stt: 'Không hoạt động',
                    ttcg: 'chưa có thông tin'
                },

                {
                    groupName: "inviv clound",
                    stt: 'Không hoạt động',
                    ttcg: 'chưa có thông tin'
                },
                {
                    groupName: "inviv clound",
                    stt: 'Không hoạt động',
                    ttcg: 'chưa có thông tin'
                },
                {
                    groupName: "inviv clound",
                    stt: 'Không hoạt động',
                    ttcg: 'chưa có thông tin'
                },
                {
                    groupName: "inviv clound",
                    stt: 'Không hoạt động',
                    ttcg: 'chưa có thông tin'
                },
                {
                    groupName: "inviv clound",
                    stt: 'Không hoạt động',
                    ttcg: 'chưa có thông tin'
                }
            ],
        }
    }
}
</script>
<style>
.user-card {
    border: 1px solid #ccc;
    border-radius: 5px;
    width: 100%;
}

.header {
    background: #ccc;
}

.con-vs-card.fixedHeight {
    height: unset !important;
    max-width: 400px !important;
}
</style>
